import React from "react";
import { Box, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";

const NoPaymentFound: React.FC = () => {
  const { t } = useKivunovaTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      gap={3}
    >
      <Typography variant="h6" color="text.primary" fontWeight="bold">
        {t("no-payments-found", "No payments found")}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t(
          "no-payments-found-description",
          "Payments are typically created from Invoices."
        )}
      </Typography>
    </Box>
  );
};

export default NoPaymentFound;
